<template>
    <div class="switch-cookie">
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch"
                   id="subscription-input" v-model="state" @change="onChange">
            <label class="form-check-label" for="subscription-input" style="white-space: nowrap">new user-access</label>
        </div>
    </div>
</template>

<script>
export default {
    name: "SwitchCookie",
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            state: null
        }
    },
    mounted() {
        this.state = $cookies.keys().includes(this.name)
    },
    methods: {
        onChange() {
            if (this.state) {
                $cookies.set(this.name, 'yes')
            } else {
                $cookies.remove(this.name)
            }
            window.location.reload()
        },
    },
}
</script>